import React from 'react'
import styles from './Card.module.css'

type DivProps = React.HTMLAttributes<HTMLDivElement>

export function Card(props: DivProps) {
  return <div className={styles.card} {...props} />
}

export function CardHeader(props: DivProps) {
  return <div className={styles.cardHeader} {...props} />
}

export function CardTitle({ children }: { children: React.ReactNode }) {
  return <h3 className={styles.cardTitle}>{children}</h3>
}

export function CardDescription({ children }: { children: React.ReactNode }) {
  return <p className={styles.cardDescription}>{children}</p>
}

export function CardContent(props: DivProps) {
  return <div className={styles.cardContent} {...props} />
}

export default Card
